export { default as DoYouHaveATrackingDevice } from './DoYouHaveATrackingDevice';
export { default as SupportedDevices } from './SupportedDevices';
export { default as FooterButtons } from './FooterButtons';
